import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { TranslationKey } from '../interfaces/TranslationKey';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/Auth.context';

const LoginSuccess = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { setAccessToken } = useAuth();
    const token = searchParams.get('token');

    useEffect(() => {
        let timeoutId: string | number | NodeJS.Timeout | undefined;
        if (token) {
            setAccessToken(token);
            timeoutId = setTimeout(() => navigate('/'), 1500);
        }

        return () => {
            clearTimeout(timeoutId);
        };
    }, [token]);

    return (
        <>
            <Helmet>
                <title>{t(TranslationKey.helmet.title.activationPage)}</title>
                <link rel="canonical" href={window.location.href} />
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <Box display={'flex'} justifyContent={'center'} alignItems={'center'} width={'100%'} height={'40vh'}>
                <Box>
                    <Typography variant="h4" align={'center'}>
                        {t(TranslationKey.accountActivation._name)}
                    </Typography>
                    <Button variant={'text'} fullWidth>
                        {t(TranslationKey.landingPage._name)}
                    </Button>
                </Box>
            </Box>
        </>
    );
};

export default LoginSuccess;
